export default `---
slug: honduras
country: Honduras
countryCode: HND
continent: Americas
year: 2019
title: "One Day, One Beach, One Sprained Ankle"
description: "A cruise ship stopover in Honduras with a sprained ankle, a beach resort, and the distinct feeling I should come back and do this properly."
thumbnail: /images/travels/HND/cover.jpg
---

I'll be upfront: I haven't actually been to Honduras in any meaningful sense.

I was doing an exchange in the United States, and we went on a cruise ship. One of the stops was Honduras. One day. A beach resort. That's the full extent of my Honduran experience, and I offer it here in good faith, with appropriate humility.

## The Ankle

Here's the context that made this particular stop special: on the <i>first day</i> of the cruise, I sprained my ankle playing basketball. Twisted it badly enough to end up on crutches for the rest of the trip.

So when we docked in Honduras and everyone headed to the beach resort, I arrived on crutches. Pale, sleep-deprived from meeting too many people and staying up too late on the ship, ankle wrapped, and armed with the very reasonable plan of <b>lying down and not moving</b>.

## The Beach

It was a nice beach. I laid on a sunbed and did very little. I didn't particularly want to bake in the sun — I was already pale enough that direct Caribbean sunlight felt like an aggressive choice — so I mostly existed horizontally, occasionally looking at the sea and thinking about how it was very blue and very inviting.

At some point I waded in and managed to snorkel a bit, because even on crutches, even half-asleep, even borderline sunburned, being in warm clear water is still being in warm clear water. <i>The sea doesn't particularly care about your orthopedic situation.</i> That part was genuinely nice.

Then I slept.

## Honduras

Look — I'm confident it's a beautiful country. The coastline suggests as much, and the water was lovely. I'd like to go back at some point and actually see it. Without crutches. With functioning legs and a full night's sleep and an actual plan.

<i>One day, Honduras. One day.</i>
`;
